
---
**Observação:** as vendas das campanhas são acumuladas no dia em que a campanha foi enviada.

Exemplo: se a campanha foi enviada no dia 10/04, 7 vendas atribuídas ocorreram no mesmo dia e 3 no dia seguinte (11/04), os valores das 10 vendas serão exibidos no dia de envio (10/04).
